import React from "react";
import styles from "./menu-lateral.module.css";
import logo from "../../../images/_finais/header-logo_compress.webp";
import BtnMenu from "./menu-lateral-btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faSignOutAlt,
  faSliders,
} from "@fortawesome/free-solid-svg-icons";
import BtnMenuLogout from "./menu-lateral-btn-logout";
// import { faUser, faPencil, faSliders } from "@fortawesome/free-solid-svg-icons";

type Props = {
  selected: string;
  onChangeSelected: (selected: string) => void;
  onClickLogout: () => void;
};

const MenuLateral = ({ selected, onChangeSelected, onClickLogout }: Props) => {
  const onHandleTab = (tab: string) => {
    if (tab === selected) return styles.navSelectedItem;

    return styles.navItem;
  };

  return (
    <div className={styles.menuLateral}>
      <div className={styles.logoContainer}>
        <img src={logo} alt="Logo" className={styles.logo} />
      </div>
      <nav className={styles.nav}>
        <ul>
          <BtnMenu
            onHandleTab={onHandleTab}
            onChangeSelected={onChangeSelected}
            icon={<FontAwesomeIcon icon={faPencil} />}
            title="Insights"
          />
          {/* <BtnMenu
            onHandleTab={onHandleTab}
            onChangeSelected={onChangeSelected}
            icon={<FontAwesomeIcon icon={faUser} />}
            title="Usuários"
          /> */}
        </ul>
      </nav>

      <>
        <BtnMenu
          onHandleTab={onHandleTab}
          onChangeSelected={onChangeSelected}
          icon={<FontAwesomeIcon icon={faSliders} />}
          title="Configurações"
        />
        <BtnMenuLogout
          onHandleTab={onHandleTab}
          onClickLogout={onClickLogout}
          icon={<FontAwesomeIcon icon={faSignOutAlt} />}
          title="Logout"
        />
      </>

      <div className={styles.copyright}>
        <span className={styles.copy_text}>
          © 2024 MDTech. Todos os direitos reservados.
        </span>
      </div>
    </div>
  );
};

export default MenuLateral;
